// TODO: Make this dynamic
import { FuturesMarketKey, FuturesMarketAsset } from '../types';
import { MarketAssetByKey, inverseObj } from '../utils';
export const V3_SYNTH_MARKET_IDS = {
    SUSD_V3: 0,
    SUSDC_V3: 1,
};
export const V3_PERPS_MARKET_IDS = {
    [FuturesMarketKey.sETHPERP]: '100',
    [FuturesMarketKey.sBTCPERP]: '200',
    [FuturesMarketKey.sSNXPERP]: '300',
    [FuturesMarketKey.sSOLPERP]: '400',
    [FuturesMarketKey.sWIFPERP]: '500',
    [FuturesMarketKey.sWPERP]: '600',
};
export const V3_SYNTH_MARKET_KEYS = Object.keys(V3_SYNTH_MARKET_IDS);
export const V3_PERPS_MARKET_IDS_TO_KEYS = inverseObj(V3_PERPS_MARKET_IDS);
export const v3PerpsMarketIdToAssetKey = (marketId) => {
    const key = V3_PERPS_MARKET_IDS_TO_KEYS[marketId];
    return MarketAssetByKey[key];
};
export const v3SynthKeyToV2Asset = (key) => {
    const asset = key.replace('S', '').replace('_V3', '');
    if (asset === 'ETH')
        return FuturesMarketAsset.sETH;
    if (asset === 'BTC')
        return FuturesMarketAsset.sBTC;
    if (asset === 'USD')
        return 'sUSD';
    return asset;
};
export const ORDERS_KEEPER_ADDRESSES = {
    84532: '0x1d1159B33a1b2A5b34B7E8A0300d1b6335bF51A1',
    8453: '0x1d1159B33a1b2A5b34B7E8A0300d1b6335bF51A1',
    // TODO: Mainnet keeper
};
export const KWENTA_PERPS_V3_REFERRAL_ADDRESS = '0x3bD64247d879AF879e6f6e62F81430186391Bdb8';
